import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_PRECISION, EXPIRY_OFFSET_HFT_DATE_FORMAT, MAX_DEPTH_NULL_VALUE, MIN_DEPTH_NULL_VALUE, MOMENT_OPTION_FORMAT, MY_STARTEGIES, Utils } from '@app/_helpers';
import { ConfigurationService, CONNECT_BROKER_TO_DEPLOY_LIVE, LegSymbol, MarketSocketService, NgxToastrService, STG_LOOP_DETECTED } from '@app/_shared';
import { EXPIRY_WEEKLY_OFFSET_TYPES_STRING, StrategyTriggerTypeMap } from '@app/_shared/modules/portfolio-form/portfolio-form.constants';
import { EXPIRY_OFFSET_TYPES_STRING, LEG_SHORT_INSTRUMENT_TYPE } from '@app/_shared/modules/portfolio-form/portfolio-form.enums';
import { GetExitParams, GlobalExitParameters, GlobalExitParamsResponse, ICondition, LegDetail, PortfolioCRUDResponse, PortfolioDisplayResponse, PortfolioRequest, StrategySymbol, UpdateMultiplier } from '@app/_shared/modules/portfolio-form/portfolio.interface';
import { MarketIDMap } from '@app/_shared/shared.enums';
import { GenericMessageResponse, PaginatedRequest } from '@app/app.interface';
import { UserListResponse } from '@app/modules/admin/providers/user-management/user-management.interfaces';
import { AuthService } from '@app/modules/auth';
import { PortfolioAPIResponse } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.interface';
import { BriefPortfolioModel } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.models';
import { MarketPlaceService } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.service';
import { cacheMapTypes, MyStrategyType } from '@app/modules/trading/modules/my-strategies/my-strategies.consts';
import cloneDeep from 'lodash-es/cloneDeep';
import { ToastrService } from 'ngx-toastr';
import { of, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActionBase, ActionType, ExpiryType, ReOrderConditionTypes, StrikeSelectionType, TriggerEventCondition, UnderlyingType, WebApiStrategyRunningType } from '../../../../utProto/webApiStrategyEnums_pb';
import { FilterOptions, SEARCH_SYMBOL_INSTRUMENT_TYPE, SearchSymbolResults, SymbolSearchService } from '../symbol-search';
import {
    ExecutePanicControlResponse,
    ExecutePortfolioRequest, ExecutePortfolioResponse,
    RegulationResponse,
    RunBacktestRequest,
    SquareOffPortfolioRequest
} from './portfolio.interface';
import { PortfolioModel, StrategyModal } from '@app/_shared/modules/portfolio-form/portfolio.model';
import { PRIMARY_STRATEGY_MISSING, STG_NOT_EXIST } from '@app/_shared/modules/portfolio-form/portfolio-form.strings';
import { EXECUTION_STYLE_NUM } from '@app/_shared/modules/strategy-form/strategy.enums';

@Injectable({
    providedIn: 'root'
})
export class PortfolioService {

    public totalActivePortfoliosCount = 0;
    public countTerminatedPortfolios = false;
    publishSelectedClients = new ReplaySubject<any>(1);

    public defaultSharePageNumber = 1;
    public defaultSharePageSize = 1000;
    isLegFormChanged:boolean = false;
    indicatorDataChanged: boolean = false;
    retainMultiplier: number = 0;



    constructor(
        private http: HttpClient,
        private confService: ConfigurationService,
        private symbolSearchService: SymbolSearchService,
        private marketSocketService: MarketSocketService,
        private authService: AuthService,
        private toastService: ToastrService,
        private router: Router,
        private marketPlaceService: MarketPlaceService,
        private toastr: NgxToastrService,
    ) { }

    // getPortfoliosByStatus(request: BriefPortfolioRequest, status: number[]) {
    //     return this.http.get<PortfolioAPIResponse>(this.confService.applicationUrls.portfolioByStatusMarketPlace,
    //         {
    //             params: { ...request, status } as any
    //         })
    //         .pipe(
    //             map((res) => {
    //                 const convertedResponse: PortfoliosResponse = {
    //                     page_number: res.page_number,
    //                     page_size: res.page_size,
    //                     total_pages: res.total_pages,
    //                     data: res.data.map(r => new BriefPortfolioModel(r)),
    //                     total_count: res.total_count
    //                 }
    //                 return convertedResponse;
    //             })
    //         )
    // }

    // getAllCompletedActivePortfolios(show_deleted?: boolean) {
    //     const request: BriefPortfolioRequest = {
    //         page_number: 0,
    //         page_size: 0
    //     }

    //     if (show_deleted) {
    //         request.show_deleted = show_deleted
    //     }

    //     return this.getPortfoliosByStatus(request, [StrategyStatus.STRATEGYSTATUS_RUNNING, StrategyStatus.STRATEGYSTATUS_PAUSED, StrategyStatus.STRATEGYSTATUS_TERMINATED]);
    // }

    getSingleBreifPortfolio(portfolioID: string, show_deleted = false, pickFromCache: boolean = false, isEdit = false) {
        if (pickFromCache) {
            const cachedPortfolio = this.getCachedPortfolio(portfolioID);
            if (cachedPortfolio) {
                return of(cachedPortfolio);
            }
        }
           
        return this.http.get<PortfolioAPIResponse>(this.confService.applicationUrls.portfolioUrl + '/' + portfolioID, { params: { show_deleted: show_deleted, is_edit: isEdit } as any })
            .pipe(
                map((res) => {
                    const length = res.data.portfolio_statuses[res.data.portfolio._id]?.length;
                    const status = res.data.portfolio_statuses[res.data.portfolio._id]?.[length - 1];
                    const backtestLength = res.data.backtest_statuses[res.data.portfolio._id]?.length;
                    const backtestStatus = res.data.backtest_statuses[res.data.portfolio._id]?.[backtestLength -1];
                    const portfolio = new BriefPortfolioModel(res.data.portfolio, status, backtestStatus);
                    this.retainMultiplier = res?.['retainMultiplier']?.['multiplier'] ?? null;
                    if(res.data.original_portfolio_details){
                        portfolio.updateOriginalPortfolioDetails([res.data.original_portfolio_details[portfolio.originalPortfolioId]]);
                    }
                    return portfolio;
                })
            );
    }

    getPortfolioDetails(portfolioID: string) {
        return this.http.get<PortfolioDisplayResponse>(this.confService.applicationUrls.getPortfolioDetails + portfolioID + '/')
    }


    getCachedPortfolio(portfolioID: string): BriefPortfolioModel | null {
        if (!this.marketPlaceService.portfoliosCachedByType) {
            return null;
        }
    
        const portfolioCached = this.marketPlaceService.portfoliosCachedByType;
        for (const type of Object.values(cacheMapTypes)) {
            if (portfolioCached.has(type)) {
                const uniquePortfolio = portfolioCached.get(type).find(portfolio => portfolio.portfolioID === portfolioID);
                if (uniquePortfolio) {
                    return uniquePortfolio;
                }
            }
        }
    
        return null;
    }

    getPortfolioFromStatus(portfolioId: string) {
        return this.http.get(this.confService.applicationUrls.getPortfolioFromStatus + '/' + portfolioId)
    }

    getSingleDetailPortfolio(portfolioID: string) {
        return this.http.get<PortfolioDisplayResponse>(this.confService.applicationUrls.createPortfolio + portfolioID + '/')
    }

    updatePortfolioState(request: ExecutePortfolioRequest, portfolioID: string) {
        // if (request.running_type === WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE && !this.authService.isVendorLogin) {
        //     this.toastService.show(CONNECT_BROKER_TO_DEPLOY_LIVE);
        //     return;
        // }
        const url = this.authService.isAdminLogin ? this.confService.applicationUrls.updatePortfolioStateAdmin : this.confService.applicationUrls.updatePortfolioState;
        return this.http.put<ExecutePortfolioResponse>(url + portfolioID + '/', request)
    }

    checkPortfolioRegulation(portfolioIds: string[]) {
        return this.http.post<RegulationResponse>(this.confService.applicationUrls.checkPortfolioRegulation, { portfolioIds })
    }

    updateMultiplier(request: UpdateMultiplier) {
        return this.http.put<any>(this.confService.applicationUrls.updateMultiplier, request);
    }

    acceptPortfolio(portfolioID: string, status: number) {
        const url = `${this.confService.applicationUrls.acceptPortfolio}${portfolioID}?status=${status}`
        return this.http.put<ExecutePortfolioResponse>(url, null);
    }

    stopAllPortfolios(clientId?: string, terminatePausedPortfolios = false, confirmation = false, is_force = false, broker?: string) {
        let params = {};

        if (terminatePausedPortfolios) {
            params['terminatePausedPortfolios'] = terminatePausedPortfolios.toString();
        }

        if (clientId) {
            params['clientId'] = clientId;
        }

        params['user_confirmation'] = confirmation;
        if (is_force) {
            params['is_force'] = is_force;
        }

        if (broker) {
            params['broker'] = broker;
        }

        const url = this.authService.isAdminLogin ? this.confService.applicationUrls.panicControlAdmin : this.confService.applicationUrls.panicControl;

        return this.http.request<ExecutePanicControlResponse>('delete', url, { body: params });
    }

    pauseAllPortfolios(confirmation = false) {
        let params = {};
        if (confirmation) {
            params['user_confirmation'] = confirmation;
        }
        const url = this.authService.isAdminLogin ? this.confService.applicationUrls.panicControlAdmin : this.confService.applicationUrls.panicControl;
        return this.http.request<ExecutePanicControlResponse>('put', url, { body: params });
    }

    bulkPortfoliosRequests(request) {
        return this.http.put<ExecutePortfolioResponse>(this.confService.applicationUrls.resumePortfolios, request);
    }

    updateRunningPortfolio(request: PortfolioRequest) {
        return this.http.put<any>(this.confService.applicationUrls.updateMultiplier, request);
    }


    createPortfolio(request: PortfolioRequest) {
        return this.http.post<PortfolioCRUDResponse>(this.confService.applicationUrls.createPortfolio, request)
    }

    updatePortfolio(request: PortfolioRequest, portfolioID: string, isSave: boolean = false) {
        return this.http.put<PortfolioCRUDResponse>(this.confService.applicationUrls.updatePortfolio + portfolioID + '/', request, {
            params: {
                isSave
            } as any
        });
    }

    hasInvalidStrategyTriggers(strategies: StrategyModal[]) {
        const strategyNames = new Set(strategies.map(stg => stg.strategyName));
        let hasInvalidTrigger = false;
        strategies.forEach(stg => {
            // TODO: validate stg trigger type
            const triggerName = stg.StrategyParams?.strategyExitParams?.trigger?.triggerName;
            if (triggerName && !strategyNames.has(triggerName)) {
                this.toastr.simpleCustomToaster(STG_NOT_EXIST(triggerName), false);
                hasInvalidTrigger = true;
            }
        })
        return hasInvalidTrigger;
    }

    hasPrimaryStrategy(strategies: StrategyModal[]) {
        const dependentStrategies = new Set(
            strategies
                .filter(s => s.StrategyParams?.strategyExitParams?.trigger?.triggerName)
                .map(s => s.StrategyParams?.strategyExitParams?.trigger?.triggerName)
        );

        let hasPrimaryStg = false;
        strategies.forEach(stg => {
            if (!dependentStrategies.has(stg.strategyName)) {
                hasPrimaryStg = true;
                stg.orderExecutionType = EXECUTION_STYLE_NUM.FULLY_AUTOMATED;
            } else {
                // Setting order execution type of dependent strategies to be dependent
                stg.orderExecutionType = EXECUTION_STYLE_NUM.DEPENDENT;
            }
        })
        if (!hasPrimaryStg) {
            this.toastr.simpleCustomToaster(PRIMARY_STRATEGY_MISSING, false);
        }
        return hasPrimaryStg;
    }

    hasCyclicStrategies(strategies: StrategyModal[]): boolean {
        const adjacencyMap = new Map<string, string>();
        strategies.forEach(strategy => {
            const triggerName = strategy.StrategyParams?.strategyExitParams?.trigger?.triggerName;
            if (triggerName) {
                adjacencyMap.set(strategy.strategyName, triggerName);
            }
        });

        const visited = new Set<string>();
        const recursionStack = new Set<string>();
        function detectCycle(node: string): boolean {
            if (recursionStack.has(node)) {
                return true;
            }

            if (visited.has(node)) {
                return false;
            }

            visited.add(node);
            recursionStack.add(node);

            const nextNode = adjacencyMap.get(node);
            if (nextNode && detectCycle(nextNode)) {
                return true;
            }

            recursionStack.delete(node);
            return false;
        }

        for (const strategy of strategies) {
            if (!visited.has(strategy.strategyName)) {
                if (detectCycle(strategy.strategyName)) {
                    this.toastr.clickableCustomToaster(STG_LOOP_DETECTED);
                    return true;
                }
            }
        }
        return false;
    }

    private createStrategyTPCondtion(strategy: StrategyModal, condiitons: ICondition[]) {
        const exitParams = strategy.StrategyParams?.strategyExitParams;
        const stgBasedAction = ActionBase.ACTIONBASE_STRATEGY;
        const stgEntryAction = ActionType.ACTIONTYPE_INVOKE;
        const reorderTriggerEvent = TriggerEventCondition.TRIGGEREVENTCONDITION_REORDER;

        if (exitParams?.tpEnabled && exitParams?.targetProfit) {
            condiitons.push({
                expression: Utils.makeConditionExpression(true),
                actions: [{
                    id: exitParams?.trigger?.triggerName,
                    actionType: stgEntryAction,
                    actionBasedOn: stgBasedAction,
                    triggerEventCondition: reorderTriggerEvent,
                    algoName: exitParams?.trigger?.triggerName
                }]
            })
        }
    }

    private createStrategySLCondition(strategy: StrategyModal, condiitons: ICondition[]) {
        const exitParams = strategy.StrategyParams?.strategyExitParams;
        const stgBasedAction = ActionBase.ACTIONBASE_STRATEGY;
        const stgEntryAction = ActionType.ACTIONTYPE_INVOKE;
        const reorderTriggerEvent = TriggerEventCondition.TRIGGEREVENTCONDITION_REORDER;

        if (exitParams.slEnabled && exitParams.stopLoss) {
            condiitons.push({
                expression: Utils.makeConditionExpression(false),
                actions: [{
                    id: exitParams?.trigger?.triggerName,
                    actionType: stgEntryAction,
                    actionBasedOn: stgBasedAction,
                    triggerEventCondition: reorderTriggerEvent,
                    algoName: exitParams?.trigger?.triggerName,
                }]
            })
        }
    }

    parseCondtions(portfolio: PortfolioModel, parseStgConditions: boolean = false): boolean {

        let isStgConditionsValid = true;

        if (parseStgConditions) {
            isStgConditionsValid = !this.hasInvalidStrategyTriggers(portfolio.strategies) && this.hasPrimaryStrategy(portfolio.strategies) && !this.hasCyclicStrategies(portfolio.strategies);
            if (!isStgConditionsValid) return isStgConditionsValid;
        }

        const lazyLegReOrder = ReOrderConditionTypes.REORDERCONDITIONTYPES_DEPENDENT;

        const legBasedAction = ActionBase.ACTIONBASE_LEG;
        const legEntryAction = ActionType.ACTIONTYPE_ENTRY;
        const reorderTriggerEvent = TriggerEventCondition.TRIGGEREVENTCONDITION_REORDER;

        let i = 1;
        let lazyLegMapArr = Array(portfolio.strategies.length).fill(null).map(() => new Map<string, number>());

        portfolio.strategies.forEach((strategy, idx) => {
            // Assigning unique legId to each leg.
            if (strategy.StrategyParams?.legs) {
                strategy.StrategyParams?.legs.forEach(leg => {
                    leg.legId = i++;

                    if (leg.legName) {
                        lazyLegMapArr[idx].set(leg.legName, leg.legId);
                    }
                });
            }
        });

        portfolio.strategies.forEach((strategy, idx) => {
            // Parsing the leg conditions for dependent legs.
            if (strategy.StrategyParams?.legs) {
                strategy.StrategyParams?.legs.forEach(leg => {
                    const conditions: ICondition[] = [];

                    // Dependent Legs on Target Profit
                    if (leg.tpReOrderParams?.reOrderType === lazyLegReOrder) {
                        conditions.push({
                            expression: Utils.makeConditionExpression(true),
                            actions: [{
                                id: `${strategy.strategyName}.${lazyLegMapArr[idx].get(leg.tpReOrderParams.reOrderLeg)}`,
                                actionType: legEntryAction,
                                actionBasedOn: legBasedAction,
                                triggerEventCondition: reorderTriggerEvent
                            }]
                        });
                    }

                    // Dependent Legs on Stop Loss
                    if (leg.slReOrderParams?.reOrderType === lazyLegReOrder) {
                        conditions.push({
                            expression: Utils.makeConditionExpression(false),
                            actions: [{
                                id: `${strategy.strategyName}.${lazyLegMapArr[idx].get(leg.slReOrderParams.reOrderLeg)}`,
                                actionType: legEntryAction,
                                actionBasedOn: legBasedAction,
                                triggerEventCondition: reorderTriggerEvent
                            }]
                        })
                    }

                    if (conditions.length) {
                        leg.conditions = conditions;
                    }
                });
            }

            if (parseStgConditions && isStgConditionsValid) {

                // Parsing the strategy conditions for strategies.
                const conditions: ICondition[] = [];
                const trigger = strategy.StrategyParams?.strategyExitParams?.trigger;
                if (trigger?.triggerEnabled) {
                    switch (trigger.triggerType) {
                        case StrategyTriggerTypeMap.TargetProfit:
                            this.createStrategyTPCondtion(strategy, conditions)
                            break;
                        case StrategyTriggerTypeMap.StopLoss:
                            this.createStrategySLCondition(strategy, conditions)
                            break;
                        case StrategyTriggerTypeMap.Both:
                            this.createStrategyTPCondtion(strategy, conditions)
                            this.createStrategySLCondition(strategy, conditions)
                            break;
                    }
                }

                if (conditions.length) {
                    strategy.StrategyParams.conditions = conditions;
                }
            }
        });

        return isStgConditionsValid;
    }

    deletePortfolio(portfolioID: string, disableStream = false) {
        let options = { params: { disableStream: disableStream.toString() } };

        return this.http.delete<GenericMessageResponse>(this.confService.applicationUrls.updatePortfolio + portfolioID + '/', options);
    }

    /**
       * @param symbol symbol name in string format
       * @param expiry expiry of the symbol
       * @param exchange exchange of symbol
       * @param ltp last trade price of symbol
       * @param stepSize Difference btw consecutive ATM selection
       * @param option_type Option type i.e CE/PE
       * @param offset Selected strike selection offset i.e ATM + 20, 0 in case of 'ATM'
       * @returns Symbol Object of calculated ATM price.
       */
    getAtmSymbolObject(symbol: string, expiry: string, exchange: string, ltp: number, stepSize: number, option_type: string, offset: number) {
        ltp = Utils.applyPrecision(ltp, DEFAULT_PRECISION) + offset;
        let atmObjects = this.symbolSearchService.advanceSearch(`${exchange} ${symbol}`, SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION, FilterOptions.strike_price, option_type, expiry);
       
       
       /* 
        ---------------Old Logic-------------
       let expectedSP = 0;
        const modResult = ltp % stepSize;
        if (modResult < stepSize / 2) {
            expectedSP = ltp - modResult;
        } else {
            expectedSP = ltp + (stepSize - modResult);
        }

        const index = atmObjects.findIndex((ele => parseFloat(ele.strike_price.toString()) === expectedSP));

        */

        // New Logic -> Finding the closest element to the LTP
        let expectedSP = (atmObjects.reduce((prev, curr) => {
            return  (Math.abs(+curr.strike_price - ltp) < Math.abs(+prev.strike_price - ltp) ? curr : prev);
        },atmObjects[0])?.strike_price);

        const index = atmObjects.findIndex((ele => parseFloat(ele.strike_price.toString()) == (expectedSP ?? 0)));


        return index != -1 ? atmObjects[index] : null;
    }

    squareOffPortfolio(portfolioID: string, request: SquareOffPortfolioRequest) {
        return this.http.post<ExecutePortfolioResponse>(this.confService.applicationUrls.squareOffPortfolio + portfolioID + '/', request)
    }

    runbacktest(portfolioID: string, request: RunBacktestRequest) {
        return this.http.post<ExecutePortfolioResponse>(this.confService.applicationUrls.backtestState + portfolioID + '/', request);
    }

    terminateBacktest(portfolioID: string) {
        return this.http.put(this.confService.applicationUrls.backtestState + portfolioID + '/', null)
    }

    async getSymbolForStrikePrice(leg: LegDetail, expectedExpiry: any, strategySymbolObj: StrategySymbol, underlying: number = UnderlyingType.UNDERLYINGTYPE_CASH) {
        let atmObj: SearchSymbolResults;
        const key = Utils.getJoinedString(leg.legSymbol.exchange, leg.legSymbol.symbol, +leg.legSymbol.optionMode,
            leg.legSymbol.expiryType, this.getExpiryOffSet(leg.legSymbol.expiryType, leg.legSymbol.expiryOffset ),
            this.getExpiryDate(leg.legSymbol.expiryType, leg.legSymbol.expiryDate), leg.legSymbol.strikeValue , strategySymbolObj.strikeSelection  == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST ? +leg.legSymbol.strikeSelection : strategySymbolObj.strikeSelection , underlying);
        const reqObj: LegSymbol = {
            exchange: leg.legSymbol.exchange,
            symbol: leg.legSymbol.symbol,
            expiryType: +leg.legSymbol.expiryType,

            expiryDate: leg.legSymbol.expiryType.toString() === ExpiryType.EXPIRYTYPE_BASIC.toString() ?
        Utils.convertDateFormat(leg.legSymbol.expiryDate, MOMENT_OPTION_FORMAT, EXPIRY_OFFSET_HFT_DATE_FORMAT) : '0',

            expiryOffset: this.getExpiryOffSet(+leg.legSymbol.expiryType, leg.legSymbol.expiryOffset),

            instrumentType: Utils.getSelectedExchanges(leg.legSymbol.exchange.toString()) ? 0 : 2,
            optionMode: +leg.legSymbol.optionMode,
            strikeSelection: strategySymbolObj.strikeSelection  == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST ? +leg.legSymbol.strikeSelection : strategySymbolObj.strikeSelection,
            strikeValue: leg.legSymbol.strikeValue,
            underlyingType: +underlying,
            itmDepth: +leg.legSymbol.itmDepth || 0,
            otmDepth: +leg.legSymbol.otmDepth || 0,
            minPriceRange: this.getMinPriceValue(leg, +strategySymbolObj.strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST ? +leg.legSymbol.strikeSelection : strategySymbolObj.strikeSelection),
            maxPriceRange: this.getMaxPriceValue(leg, +strategySymbolObj.strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST ? +leg.legSymbol.strikeSelection : strategySymbolObj.strikeSelection),
            timestamp: Date.now(),

        }
        const response = await this.marketSocketService.getStrikePrice(reqObj, key);
        if (response) {
            const strikePriceSymbol = this.symbolSearchService.advanceSearch(
                `${MarketIDMap[leg.legSymbol.exchange]} ${leg.legSymbol.symbol}`, SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION,
                FilterOptions.symbol, LEG_SHORT_INSTRUMENT_TYPE[leg.legSymbol.optionMode], expectedExpiry, (+response).toFixed(DEFAULT_PRECISION).toString()
            );
            atmObj = strikePriceSymbol[0]
        }
        return atmObj;
    }

    getMinPriceValue(leg: LegDetail, strikeSelection: number): number {
        if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_RANGE) {
            return +leg.legSymbol.minPriceRange;
        } else if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_ABOVE) {
            return leg.legSymbol.strikeValue;
        } else if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_BELOW && leg.legSymbol.rangePercentageEnabled) {
            const strikePrice = leg.legSymbol.strikeValue;
            return strikePrice - (strikePrice * (leg.legSymbol.rangePercentageValue / 100));
        } else {
            return MIN_DEPTH_NULL_VALUE;
        }
    }

    getMaxPriceValue(leg: LegDetail, strikeSelection: number): number {

        if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_RANGE) {
            return +leg.legSymbol.maxPriceRange;
        } else if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_BELOW) {
            return leg.legSymbol.strikeValue;
        } else if (strikeSelection == StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_ABOVE && leg.legSymbol.rangePercentageEnabled) {
            const strikePrice = leg.legSymbol.strikeValue;
            return strikePrice + (strikePrice * (leg.legSymbol.rangePercentageValue / 100));
        } else {
            return MAX_DEPTH_NULL_VALUE;
        }
    }

    getExpiryOffSet(expiryType: number, expiryOffSet: number) {
        return expiryType === ExpiryType.EXPIRYTYPE_BASIC ? 0 : expiryOffSet
    }

    getExpiryDate(expiryType: number, expiryDate: string) {
        return expiryType === ExpiryType.EXPIRYTYPE_BASIC ? expiryDate : '0'
    }

    /**
     * below function fetches all the symbols matching with the underlying selected by the user
     * Later unique expiries are filtered from the searched results.
     */
    getMonthlyWeeklyExpiryOffSet(value: string, expiryType: FilterOptions) {
        switch (expiryType) {
            case FilterOptions.monthly:
                const UniqueMonths = this.symbolSearchService.advanceSearch(value, SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION,
                    FilterOptions.symbol)?.map(el => el.expiry.slice(2, 5)).filter((v, i, a) => a.indexOf(v) === i);
                /**
                 * expiry looks like eg: 27APR23
                 * from expiry slicing the month and getting unique months
                 * based on the length of uniques months expiryOffsetValues are returned
                 */
                const expiry_monthly_results = cloneDeep(EXPIRY_OFFSET_TYPES_STRING)
                if (UniqueMonths.length === 1) {
                    delete expiry_monthly_results[1]
                    delete expiry_monthly_results[2]
                    return expiry_monthly_results
                }
                else if (UniqueMonths.length === 2) {
                    delete expiry_monthly_results[2]
                    return expiry_monthly_results
                }
                else {
                    return EXPIRY_OFFSET_TYPES_STRING
                }

            case FilterOptions.weekly:
                let searchResults = this.symbolSearchService.advanceSearch(value, SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION,
                    FilterOptions.symbol)?.map(el => el.expiry).filter((v, i, a) => a.indexOf(v) === i);
                /**
                 * for weekly case if unique expiries list length is >= Weekly offset then
                 * directly return weekly offsets
                 * else slicing weekly offsets upto the length of searchresults
                 */
                if (searchResults.length >= EXPIRY_WEEKLY_OFFSET_TYPES_STRING.length) {
                    return EXPIRY_WEEKLY_OFFSET_TYPES_STRING
                }
                return EXPIRY_WEEKLY_OFFSET_TYPES_STRING.slice(0, searchResults.length)
        }
    }

    openAnalytics(portfolioId: string, link: string, uniquePortfolioID: string = null) {
        const data = uniquePortfolioID ? { portfolioId, uniquePortfolioID, type: MyStrategyType.Deployed, comingFrom: MY_STARTEGIES } : { portfolioId, type: MyStrategyType.Deployed, comingFrom: MY_STARTEGIES };
        this.router.navigate([link], {
            queryParams: data,
        });
    }

    updateExitParams(portfolioId: string, portfolioObj: PortfolioRequest) {
        const url = this.confService.applicationUrls.updateExitParams + portfolioId;
        return this.http.post<PortfolioCRUDResponse>(url, portfolioObj);
    }


    getExitParams(portfolioId: string) {
        const url = this.confService.applicationUrls.getExitParams + portfolioId;
        return this.http.get<GetExitParams>(url);
    }

    resetExitParams(portfolioId: string) {
        const url = this.confService.applicationUrls.resetExitParams + portfolioId;
        return this.http.delete<GetExitParams>(url);
    }

    copyPortfolio(portfolioId: string, portfolioObj: any) {
        const url = this.confService.applicationUrls.copyPortfolio + portfolioId;
        return this.http.post<GetExitParams>(url, portfolioObj);
    }

    updateCopyPortfolioVersion(portfolioId: string, portfolioObj: any) {
        const url = this.confService.applicationUrls.updateCopyPortfolioVersion + portfolioId;
        return this.http.post<GetExitParams>(url, portfolioObj);
    }

    getGlobalExitParams() {
        return this.http.get<GlobalExitParamsResponse>(this.confService.applicationUrls.globalExitUrl)
    }

    updateGlobalExitParams(request: GlobalExitParameters) {
        return this.http.put<GlobalExitParamsResponse>(this.confService.applicationUrls.globalExitUrl, request)
    }

    getUserList(pageNumber = this.defaultSharePageNumber, pageSize = this.defaultSharePageSize, userQuery = null, lockedUser = false, clients?:string) {
        const req: PaginatedRequest = {
            page_number: pageNumber,
            page_size: pageSize
        }

        if (userQuery) {
            req.query = userQuery;
        }

        if (clients) {
            req.clientsList = clients;
        }
        req.lockedUser = lockedUser;
        return this.http.get<UserListResponse[]>(this.confService.applicationUrls.listShareClients, {
            params: req as any
        });
    }

    shareWithUsers(portfolioId: string, request: any) {
        const url = this.confService.applicationUrls.shareWithClients + portfolioId;
        return this.http.put<GenericMessageResponse>(url, request);
    }

    clearNewClientsData() {
        this.publishSelectedClients = new ReplaySubject<any>(1);
    }
}